import Accessibility from '@img/icons/accessibility.svg';
import ArrowRight from '@img/icons/arrow-right.svg';
import BookmarkAdd from '@img/icons/bookmark-add.svg';
import BookmarkRemove from '@img/icons/bookmark-remove.svg';
import Chevron from '@img/icons/chevron.svg';
import Cross from '@img/icons/cross.svg';
import Download from '@img/icons/download.svg';
import External from '@img/icons/external.svg';
import FacebookFull from '@img/icons/facebook-full.svg';
import Facebook from '@img/icons/facebook.svg';
import Instagram from '@img/icons/instagram.svg';
import Link from '@img/icons/link.svg';
import LinkedinFull from '@img/icons/linkedin-full.svg';
import Linkedin from '@img/icons/linkedIn.svg';
import LockClose from '@img/icons/lock-close.svg';
import LockOpen from '@img/icons/lock-open.svg';
import Play from '@img/icons/play.svg';
import Search from '@img/icons/search.svg';
import Tick from '@img/icons/tick.svg';
import TwitterFull from '@img/icons/twitterx-full.svg';
import Twitter from '@img/icons/twitterx.svg';
import WaveSvg from '@img/icons/wave.svg';
import Youtube from '@img/icons/youtube.svg';
import React from 'react';
export var SystemIcon;
(function (SystemIcon) {
    SystemIcon["Accessibility"] = "accessibility";
    SystemIcon["ArrowRight"] = "arrow-right";
    SystemIcon["BookmarkAdd"] = "bookmark-add";
    SystemIcon["BookmarkRemove"] = "bookmark-remove";
    SystemIcon["Chevron"] = "chevron";
    SystemIcon["Cross"] = "cross";
    SystemIcon["Download"] = "download";
    SystemIcon["External"] = "external";
    SystemIcon["Facebook"] = "facebook";
    SystemIcon["FacebookFull"] = "facebook-full";
    SystemIcon["Instagram"] = "instagram";
    SystemIcon["Link"] = "link";
    SystemIcon["Linkedin"] = "linkedin";
    SystemIcon["LinkedinFull"] = "linkedin-full";
    SystemIcon["LockClose"] = "lock-close";
    SystemIcon["LockOpen"] = "lock-open";
    SystemIcon["Play"] = "play";
    SystemIcon["Search"] = "search";
    SystemIcon["Tick"] = "tick";
    SystemIcon["Twitter"] = "twitter";
    SystemIcon["TwitterFull"] = "twitterx-full";
    SystemIcon["Wave1"] = "wave1";
    SystemIcon["Youtube"] = "youtube";
})(SystemIcon || (SystemIcon = {}));
export function getSvgFromSystem(icons) {
    switch (icons) {
        case SystemIcon.Accessibility: {
            return React.createElement(Accessibility, null);
        }
        case SystemIcon.ArrowRight: {
            return React.createElement(ArrowRight, null);
        }
        case SystemIcon.BookmarkAdd: {
            return React.createElement(BookmarkAdd, null);
        }
        case SystemIcon.BookmarkRemove: {
            return React.createElement(BookmarkRemove, null);
        }
        case SystemIcon.Chevron: {
            return React.createElement(Chevron, null);
        }
        case SystemIcon.Cross: {
            return React.createElement(Cross, null);
        }
        case SystemIcon.Download: {
            return React.createElement(Download, null);
        }
        case SystemIcon.External: {
            return React.createElement(External, null);
        }
        case SystemIcon.Facebook: {
            return React.createElement(Facebook, null);
        }
        case SystemIcon.FacebookFull: {
            return React.createElement(FacebookFull, null);
        }
        case SystemIcon.Instagram: {
            return React.createElement(Instagram, null);
        }
        case SystemIcon.Link: {
            return React.createElement(Link, null);
        }
        case SystemIcon.Linkedin: {
            return React.createElement(Linkedin, null);
        }
        case SystemIcon.LinkedinFull: {
            return React.createElement(LinkedinFull, null);
        }
        case SystemIcon.LockClose: {
            return React.createElement(LockClose, null);
        }
        case SystemIcon.LockOpen: {
            return React.createElement(LockOpen, null);
        }
        case SystemIcon.Play: {
            return React.createElement(Play, null);
        }
        case SystemIcon.Search: {
            return React.createElement(Search, null);
        }
        case SystemIcon.Tick: {
            return React.createElement(Tick, null);
        }
        case SystemIcon.Twitter: {
            return React.createElement(Twitter, null);
        }
        case SystemIcon.TwitterFull: {
            return React.createElement(TwitterFull, null);
        }
        case SystemIcon.Wave1: {
            return React.createElement(WaveSvg, null);
        }
        case SystemIcon.Youtube: {
            return React.createElement(Youtube, null);
        }
        default: {
            return null;
        }
    }
}
